// extracted by mini-css-extract-plugin
module.exports = {"page":"ManagerList_page__2EPK3","mainTable":"ManagerList_mainTable__3Q0NR"};